import './Blanket.scss';

import React, { DOMAttributes, forwardRef, ReactNode } from 'react';

interface IProps extends DOMAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export default forwardRef<HTMLDivElement, IProps>(function Blanket({ children, ...props }: IProps, ref) {
  return (
    <div className="novoBlanket" {...props} ref={ref}>
      {children}
    </div>
  );
});
